import React from "react";
import image from "../images/homepage.svg";
import Value from "../components/Value";
import AboutCarousel from "../components/AboutCarousel";
// import TeamSection from "../components/Team";
import Expertise from "../components/Expertise";
import CommitmentAndTeam from "../components/CommitmentAndTeam";
import BenefitsTabs from "../components/Benefits";

const About = () => {
  return (
    <div className="relative">
      <img
        className="h-auto w-full object-cover"
        src={image}
        alt="About"
      />

      <div className="mt-6 mx-8">
      <h2 className="text-3xl font-semibold text-center mb-6 text-[#13689b] py-4 rounded-lg">About</h2>
        <p className="mx-8 mt-4 mb-4 text-black text-justify">
          At WhyMe Solutions, we deploy cutting-edge strategies to drive your
          business forward with innovative digital marketing and comprehensive
          IT services. Our approach combines advanced technology with strategic
          insight, ensuring your business stands out in a competitive market.
          Discover how our tailored solutions can transform your brand and
          optimize your IT infrastructure for unparalleled success. 
        </p>

        <p className="mx-8 mb-4 text-black text-justify">
        This is where transformative ideas meet strategic insight. As a premier
          multidisciplinary consulting agency, we excel in delivering bespoke
          solutions that drive success and innovation across diverse sectors.
          Our goal is to elevate organizations by leveraging our extensive
          expertise and cutting-edge methodologies.
        </p>

        <Expertise />

        {/* <div className="border border-1 border-[#13689b] mt-4"></div> */}
      </div>

      <div className="mt-8 mx-4">
      <h1 className="text-3xl font-semibold text-center mb-8 text-[#13689b] py-4 rounded-lg">We Do Better Together</h1>

        <div className="m-6">
          <p className="text-md mx-2">
          Our eight core values that help create a strong, unified identity for the agency, guiding its operations and client interactions in a meaningful way.
          </p>
        </div>

        <Value />
        <BenefitsTabs/>

        <CommitmentAndTeam />

        
       
        <div className="m-6">
          <AboutCarousel />
        </div>

        {/* <TeamSection /> */}
      </div>
    </div>
  );
};

export default About;
